import { useEffect, useState } from 'react';

import { useSelector, useStore } from 'editor/src/store/hooks';

import { getPersonalizationPricingSession } from 'editor/src/util/personalizationPricing/runtime';

/**
 * True while the quote on screen is not the host's answer for what the shopper sees: a stepped quantity it has
 * not quoted yet, or print areas it is still pricing. The host keeps the last quote during the latter rather than
 * letting it flicker away, and clears its price, which is when the plain header shows no price at all.
 */
function useIsQuantitySavingsPending() {
  const store = useStore();
  const pricingSession = getPersonalizationPricingSession(store);
  const isQuantityPending = useSelector((state) => state.quantitySavings.pendingQuantity !== undefined);
  const [pricingState, setPricingState] = useState(pricingSession.getState());
  const [hostPrice, setHostPrice] = useState(pricingSession.getPrice());
  useEffect(() => pricingSession.subscribe(setPricingState), [pricingSession]);
  useEffect(() => pricingSession.subscribePrice(setHostPrice), [pricingSession]);

  return isQuantityPending || (pricingState.status !== 'disabled' && hostPrice === null);
}

export default useIsQuantitySavingsPending;
